import React from 'react';
import { Loading } from '../loading/loading';

export type ToggleState = 'on' | 'off' | 'disabled';

export interface ToggleProps {
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  state: 'on' | 'off' | 'disabled';
  size?: 'small' | 'medium' | 'large';
  fontSize?: string;
  id?: string;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  className?: string;
  loading?: boolean;
  'data-test-id'?: string;
}

export const Toggle = ({
  disabled = false,
  onChange,
  onClick,
  state,
  size = 'medium',
  fontSize,
  id,
  className,
  loading = false,
  'data-test-id': dataTestId,
}: ToggleProps) => {
  const checked = state === 'on';
  const container =
    'flex relative rounded-full items-center p-[0.19rem] cursor-pointer transition-all ease-in-out duration-200';
  const thumbStyle = `flex absolute justify-center items-center rounded-full transition-all ease-in-out duration-200 ${
    checked ? 'right-[0.19rem]' : ''
  }`;

  return (
    <div
      data-test-id={dataTestId}
      className={` ${disabled ? 'bg-input-bg-disabled! cursor-disabled' : ''} ${size === 'small' ? 'h-3.5 w-7' : ''} ${size === 'medium' ? 'h-[1.125rem] w-9' : ''} ${size === 'large' ? 'h-[1.275rem] w-11' : ''} ${state === 'on' ? 'bg-primary-600' : ''} ${state === 'off' ? 'bg-slate-300' : ''} ${state === 'disabled' ? 'bg-input-bg-disabled' : ''} ${container} ${className} `}
      style={{ fontSize: fontSize }}
    >
      <div
        className={` ${size === 'small' ? 'h-2 w-2' : ''} ${size === 'medium' ? 'h-3 w-3' : ''} ${size === 'large' ? 'h-4 w-4' : ''} ${checked ? 'right-[0.19rem]' : ''} ${state === 'on' ? 'bg-input-bg' : ''} ${state === 'off' ? 'bg-input-bg' : ''} ${state === 'disabled' ? 'bg-input-disabled' : ''} ${thumbStyle}`}
      />
      <input
        onClick={onClick}
        onChange={onChange ? (!disabled ? onChange : () => {}) : () => {}}
        id={id}
        className="flex h-full w-full cursor-pointer p-5 opacity-0"
        type="checkbox"
        checked={checked}
      />
      {loading ? <Loading size="small" /> : <></>}
    </div>
  );
};
